import { z } from "zod";

// TES-1056 (TES-1054 point F) — the doctor's assessment of a patient-reported
// blood pressure / resting pulse occasion.
//
// Emelie 2026-10-01, verbatim:
// "Patientens värden ska inte märkas Verifierade/inte verifierade."
// "Kirill bedömer om mätningen kan användas men verifierar inte att patienten har mätt korrekt och ska inte skriva över patientens värden."
// "Journalen tar med faktiska värden, mätdatum, källa och Kirills bedömning. Systemet får inte automatiskt formulera ett normalt fynd."
//
// So this is a status BESIDE her values (MeasurementSession.reviewStatus),
// never a change to them, and the journal line below is a fixed template:
// value, date, source, assessment. It never says what the value means.

export const MEASUREMENT_REVIEW_STATUSES = [
  "patient_reported",
  "reviewed_as_basis",
  "needs_new_measurement",
] as const;
export const measurementReviewStatusSchema = z.enum(
  MEASUREMENT_REVIEW_STATUSES,
);
export type MeasurementReviewStatus = z.infer<
  typeof measurementReviewStatusSchema
>;

// Her three labels, verbatim (TES-1054 F).
export const MEASUREMENT_REVIEW_STATUS_LABEL: Record<
  MeasurementReviewStatus,
  string
> = {
  patient_reported: "Patientrapporterat",
  reviewed_as_basis: "Granskat som medicinskt underlag",
  needs_new_measurement: "Behöver ny mätning",
};

// PATCH employee-api/v1/patients/:patientId/measurement-sessions/:sessionId/review
export const reviewMeasurementSessionSchema = z
  .object({ status: measurementReviewStatusSchema })
  .strict();
export type ReviewMeasurementSession = z.infer<
  typeof reviewMeasurementSessionSchema
>;

// Simon 2026-10-01 — the doctor's own separate reading (TES-1034, #1096) is
// kept, but never called "verifierad".
export const CLINICIAN_READING_LABEL = "Mätning registrerad av läkare";

/**
 * Whether an occasion's source is the patient's own report — the only kind
 * the doctor assesses. His own reading carries no review status.
 */
export function isPatientReportedSource(source: string): boolean {
  return source !== "clinician";
}
